import { useBCMSModal } from "@bcm-dev/bcms-vite";
import CustomModal, { CustomModalContent, CustomModalFooter, ModalCloseButton, ModalPrimaryButton } from "compid/custom-ui/CustomModal";
import React from "react";
import { SVGAsset } from "res";

import "./styles.css";

/**
 * @function EditBillerGroupModal
 * @param {STRING} onClick - Sets an event handler on click. 
 * @returns {React.Component}
 * @exported true
 * @description This modal shows when you edit a biller group.
 */
export default function EditBillerGroupModal(props) {
    const { close } = useBCMSModal();
    const data = props.data ?? {};
    const billerGroup = data.billerGroup ?? {};
    const billerGroupName = data.billerGroupName ?? "[billerName]";
    const billerGroupEditItem = data.billerGroupEditItem;
    const editedBillerGroup = billerGroupEditItem ? billerGroupEditItem.editedBillerGroup : {};
    const editedBillerGroupName = editedBillerGroup.name === "" ? billerGroupEditItem.billerGroup.name : editedBillerGroup.name;
  
    const onClick = () => {
        const obj = { billerGroupEditItem: billerGroupEditItem,
            billerGroup: billerGroup };
        data.onPrimaryButtonClick(obj);
        close("EditBillerGroupModal");
    };

    return (
        <CustomModal id="EditBillerGroupModal" className="edit-biller-group-modal large-icon-modal">
            <CustomModalContent className="flex-container flex-horizontal">
                <div className="set-width modal-icon">
                    <SVGAsset id="EditIcon" className="edit-icon left-icon" />
                </div>
                <div className="flex-width">
                    <h4 className="modal-title"><b>Edit biller group</b></h4>
                    <p className="sub-text">Are you sure you want to edit <b>{ billerGroupName }</b> to <b>{ editedBillerGroupName }</b>?</p>
                </div>
            </CustomModalContent>
            <CustomModalFooter className="form-button-container">
                <ModalCloseButton text="Cancel" id="EditBillerGroupModal" />
                <ModalPrimaryButton text="Confirm" onClick={ onClick } />
            </CustomModalFooter>
        </CustomModal>
    )
}
